// src/pages/auth/SubscriptionPage.jsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { useTranslation } from 'react-i18next'; 
import { ArrowLeft, Loader2, AlertCircle } from "lucide-react";
import SubscriptionStep from "./SubscriptionStep";
import { getAllSubscriptionPlans, purchaseSubscription } from "../../../services/auth.service";
import { submitPaywallForm } from "../../../utils/payzone";



export default function SubscriptionPage() {
  const { t } = useTranslation('auth'); 
  const navigate = useNavigate();
  const location = useLocation();
  const { customerType, customerId, token, email } = location.state || {};
  
  const [selectedPlan, setSelectedPlan] = useState("");
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState<any[]>([]);
  const [error, setError] = useState("");
  const [pageLoading, setPageLoading] = useState(true);

  useEffect(() => {
    loadPlans();
  }, [customerType]);

  const loadPlans = async () => {
    try {
      setPageLoading(true);
      setError("");
      
      let subscriptionCustomerType = 1;
      if (customerType === 3) {
        subscriptionCustomerType = 2;
      } else if (customerType === 2) {
        subscriptionCustomerType = 1;
      } else {
        subscriptionCustomerType = 1;
      }

      console.log("Fetching plans for customerType:", subscriptionCustomerType);
      
      const res = await getAllSubscriptionPlans(subscriptionCustomerType);
      
      console.log("Plans response:", res);
      
      if (res.success) {
        setPlans(res.data || []);
      } else {
        setError(res.message || "Failed to load plans");
      }
    } catch (err: any) {
      console.error("Error loading plans:", err);
      setError(err?.response?.data?.message || "Failed to load subscription plans");
    } finally {
      setPageLoading(false);
    }
  };

  // const handleContinue = async () => {
  //   if (!selectedPlan) {
  //     setError("Please select a subscription plan");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     setError("");
      
  //     const res = await purchaseSubscription(selectedPlan);
      
  //     console.log("Purchase Response:", res);
      
  //     if (res.success) {
  //       navigate("/auth/account-created", {
  //         state: {
  //           customerType,
  //           customerId,
  //           email,
  //           subscription: res.data,
  //         },
  //       });
  //     } else {
  //       setError(res.message || "Failed to purchase subscription");
  //     }
  //   } catch (error: any) {
  //     console.error("Purchase error:", error);
  //     const errorMessage = error?.response?.data?.message || "Failed to purchase subscription. Please try again.";
  //     setError(errorMessage);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const handleContinue = async () => {
  if (!selectedPlan) {
    setError("Please select a subscription plan");
    return;
  }

  try {
    setLoading(true);
    setError("");

    // Backend sirf payment session banata hai — subscription NAHI.
    const res = await purchaseSubscription(selectedPlan);

    if (!res.success) {
      setError(res.message || "Failed to initiate payment");
      setLoading(false);
      return;
    }

    // Signup context save karo — PaymentSuccessPage ise use karega
    // taaki Payzone se wapas aane ke baad /auth/account-created pe ja sake.
    sessionStorage.setItem(
      "payzone_signup_ctx",
      JSON.stringify({ customerType, customerId, email })
    );

    // Browser ko Payzone ki paywall pe bhej do.
    submitPaywallForm(
      res.data.paywallUrl,
      res.data.payloadJson,
      res.data.signature
    );

    // Yahan loading(false) NAHI karna — page navigate ho raha hai.
    // Browser jaise hi Payzone pe jayega, ye component unmount ho jayega.
  } catch (error: any) {
    console.error("Purchase initiation error:", error);
    setError(
      error?.response?.data?.message ||
        "Failed to initiate payment. Please try again."
    );
    setLoading(false);
  }
};

  if (!customerType) {
    navigate("/register");
    return null;
  }

  if (pageLoading) {
    return (
      <div className="w-full max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl border border-[#E5E7EB] p-8">
          <div className="flex justify-center items-center py-16">
            <Loader2 className="w-8 h-8 animate-spin text-[#1E6DFF]" />
            <span className="ml-3 text-[#717182]">Loading subscription plans...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="bg-white rounded-2xl shadow-xl border border-[#E5E7EB] p-8">
        {/* Header */}
        <div className="flex items-center gap-3 mb-8">
          <button
            onClick={() => navigate(-1)}
            className="p-2 rounded-xl hover:bg-[#F5F7FA] transition-colors"
          >
            <ArrowLeft className="w-5 h-5 text-[#2D323A]" />
          </button>
          <div>
            <p className="text-xs text-[#717182]">
              {customerType === 3 ? "Company" : "Personal Seller"} Account
            </p>
            <h2 className="text-2xl text-[#2D323A]">{t('register.subscription.title')}</h2>
          </div>
        </div>

        <p className="text-[#717182] mb-6">
          {t('register.subscription.description')}
        </p>

        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4 mb-6 flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div>
              <p className="text-red-700 font-medium">Error</p>
              <p className="text-red-600 text-sm">{error}</p>
              <button 
                onClick={loadPlans}
                className="mt-2 text-sm text-red-700 underline hover:no-underline"
              >
                Try again
              </button>
            </div>
          </div>
        )}

        {/* Subscription Plans */}
        <SubscriptionStep
          plans={plans}
          type={customerType === 3 ? "company" : "personal"}
          selected={selectedPlan}
          onSelect={setSelectedPlan}
        />

        {/* Continue Button */}
        <button
          onClick={handleContinue}
          disabled={loading || !selectedPlan}
          className="w-full mt-8 py-3 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? (
            <>
              <Loader2 className="w-5 h-5 animate-spin" />
              {t('register.subscription.processing')}
            </>
          ) : (
            t('register.subscription.continue')
          )}
        </button>

        {/* Footer Note */}
        <p className="text-xs text-[#717182] text-center mt-4">
          {t('register.subscription.footer')}
        </p>
      </div>
    </div>
  );
}